<template>
    <div id="attribute-form">
        <top-section>
            {{ title }}
            <template v-slot:buttons>
                <b-button tag="button"
                          type="is-primary"
                          class="is-uppercase"
                          :label="buttonLabel"
                          rounded @click.prevent="submit"
                          outlined></b-button>
            </template>
        </top-section>

        <div class="section">
            <b-field :label="__('strings.attribute.form.name')"
                     label-position="on-border"
                     :type="{ 'is-danger': errors.name }"
                     :message="errors.name" horizontal>
                <b-input :placeholder="__('strings.attribute.form.name')"
                         type="text" name="name"
                         v-model="input.name" @focus="clearError"></b-input>
            </b-field>

            <b-field :label="__('strings.attribute.form.code')"
                     label-position="on-border"
                     :type="{ 'is-danger': errors.code }"
                     :message="errors.code" horizontal>
                <b-input :placeholder="__('strings.attribute.form.code')"
                         type="text" name="code" :disabled="isReadOnly"
                         v-model="input.code" @focus="clearError"></b-input>
            </b-field>

            <b-field :label="__('strings.attribute.form.type')"
                     label-position="on-border"
                     :type="{ 'is-danger': errors.type }"
                     :message="errors.type" horizontal>
                <b-select :placeholder="__('strings.attribute.form.type')" name="type"
                         v-model="input.type" @change="clearError" expanded>
                    <option value="string">String</option>
                    <option value="text">Text</option>
                    <option value="integer">Integer</option>
                </b-select>
            </b-field>

            <b-field :label="__('strings.attribute.form.entity_type')"
                     :type="{ 'is-danger': errors.entity_type }"
                     :message="errors.entity_type" horizontal>
                <b-select :placeholder="__('strings.attribute.form.entity_type')" name="entity_type"
                          v-model="input.entity_type" @change="clearError" expanded>
                    <option value="product">Product</option>
                </b-select>
            </b-field>

            <b-field :type="{ 'is-danger': errors.updatable }"
                     :message="errors.updatable" 
                     horizontal>    
                <template slot="label">
                    <span>
                        <b-tooltip
                            :label="__('strings.attribute.form.updatable_by_source_tooltip')"
                            type="is-dark"
                            multilined>
                            <b-icon icon="alert-circle" size="is-small"></b-icon>
                        </b-tooltip>
                    </span>
                    <span>{{__('strings.attribute.form.updatable_by_source')}}</span>    
                </template>            
                <b-switch name="updatable" v-model="input.updatable"></b-switch>
            </b-field>

            <div class="section is-flex">
                <b-button tag="button"
                          type="is-primary"
                          class="is-uppercase"
                          :label="buttonLabel"
                          rounded style="margin-left: auto"
                          @click.prevent="submit"
                          outlined></b-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                errors: {
                    name: '',
                    code: '',
                    type: '',
                    entity_type: '',
                    updatable: ''
                },
                input: {
                    name: '',
                    code: '',
                    type: 'string',
                    entity_type: 'product',
                    updatable: false
                },
                item: null
            }
        },
        mounted() {
            if (this.$route.params.hasOwnProperty('routeKey') && this.$route.params.routeKey) {
                axios.get('/attribute/edit/' + this.$route.params.routeKey)
                    .then(response => {
                        this.item = response.data
                        this.input = Object.assign({}, response.data)
                    })
            }
        },
        methods: {
            submit() {
                let method = this.item ? 'patch' : 'post';
                let url = this.item ? `/update/attribute/${this.$route.params.routeKey}` : '/store/attribute';
                axios({method, url, data: this.input})
                    .then(response => {
                        if (!this.item) {
                            this.$router.push({
                                name: 'model.action',
                                params: {
                                    resource: 'attribute',
                                    action: 'edit',
                                    routeKey: response.data.id
                                }
                            });
                        }

                        let translationKey = this.item ? 'messages.model.updated' : 'messages.model.created';
                        this.item = Object.assign({}, response.data)
                        this.toaster(this.__(translationKey, {name: this.__('strings.models.attribute')}), "is-success")
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;
                        this.toaster(error.response.data.message, "is-danger")
                    });
            },
            toaster(message, type) {
                this.$buefy.snackbar.open({
                    message,
                    type,
                    position: 'is-bottom-right',
                    actionText: 'Ok',
                })
            },
            clearError(event) {
                this.errors[event.target.name] = "";
            }
        },
        computed: {
            title() {
                return this.$route.params.hasOwnProperty('routeKey') && this.$route.params.routeKey ? this.__('strings.attribute.form.edit_attribute') : this.__('strings.attribute.form.create_attribute');
            },
            buttonLabel() {
                return this.$route.params.hasOwnProperty('routeKey') && this.$route.params.routeKey ? this.__('strings.attribute.form.save_attribute') : this.__('strings.attribute.form.create_attribute');
            },
            isReadOnly() {
                return !! this.item;
            }
        }
    }
</script>